<template>
  <div
    class="course__item"
    :class="{
      'course__item--vertical': vertical
    }"
  >
    <div
      v-if="event.image"
      class="course__item-image"
    >
      <img
        class="course__item-image-element"
        :src="event.image"
        alt="event image"
        loading="lazy"
      />
    </div>
    <div class="course__item-details">
      <h3
        v-if="event.title"
        class="course__item-title"
        v-sanitize="event.title"
      />
      <span
        class="course__item-date"
        v-sanitize="formatDate(event.date)"
      />
      <div
        v-if="showDescription && event.description"
        class="course__item-description"
        v-sanitize="event.description"
      />
      <div class="course__item-info">
        <div class="course__item-info-row">
          <SVGLocation class="course__item-info-icon"/>
          <strong
            class="course__item-info-text"
            v-sanitize="formatLocation(event.location)"
          />
        </div>
        <div class="course__item-info-row">
          <SVGClock class="course__item-info-icon"/>
          <span
            class="course__item-info-text"
            v-sanitize="formatTime(event, isEvent)"
          />
        </div>
        <div
          v-if="!isEvent && !isBooking"
          class="course__item-info-row"
        >
          <SVGSpeechBubble class="course__item-info-icon"/>
          <span
            class="course__item-info-text"
            v-sanitize="$t(`course.language.${event.locale}`)"
          />
        </div>
        <div
          v-if="!isEvent && !isBooking"
          class="course__item-info-row"
        >
          <SVGUsers class="course__item-info-icon"/>
          <span
            class="course__item-info-text"
            v-sanitize="$tc('course.freePlacesCount', event.free, { count: event.free })"
          />
        </div>
        <div
          class="course__item-info-row"
        >
          <SVGMoney class="course__item-info-icon"/>
          <strong
            v-if="event.price"
            class="course__item-info-text"
            v-sanitize="$options.filters.fwgpricecent(event.price, 'html')"
          />
          <strong
            v-else
            class="course__item-info-text"
            v-sanitize="$t('course.free')"
          />
        </div>
      </div>
      <div
        v-if="showDetailsButton || buttonText"
        class="course__item-buttons"
      >
        <Button
          v-if="showDetailsButton"
          :text="$t('course.detailsButton')"
          level="secondary"
          type="button"
          small
          block
          @click="$emit('course:info', event)"
        />
        <Button
          v-if="buttonText"
          :text="buttonText"
          level="primary"
          type="button"
          small
          block
          @click="$emit('course:select', event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MixinCourse from '@/mixins/MixinCourse'
import Button from '@/components/Button'

export default {
  mixins: [
    MixinCourse,
	],
	components: {
		Button,
	},
  props: {
    event: {
      type: Object,
      required: true
    },
    buttonText: String,
    showDescription: Boolean,
    vertical: Boolean,
  },
  computed: {
    eventType() {
      return this.event.type
    },
    showDetailsButton() {
      return !this.showDescription && this.event.description
    }
  }
}
</script>
